import React from 'react'
import { Box } from './misc';
import styled, { css } from '../utils/style';

const Container = styled(Box)(
  css({ maxWidth: 1180, margin: "0 auto", padding: [0, "0 4vw", "0 4vw"] })
)

export default Container
